(function () {
  'use strict';

  if (window.__supplementaBisLoaded) return;
  window.__supplementaBisLoaded = true;

  var configEl = document.getElementById('supplementa-bis-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (err) {
    return;
  }

  var dialog = null;
  var opener = null;
  var emailInput = null;
  var titleEl = null;
  var introEl = null;
  var fieldsEl = null;
  var messageEl = null;
  var submitBtn = null;

  function closeIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '2.75 2.75 10.5 10.5');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M4.5 4.5l7 7M11.5 4.5l-7 7');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('stroke-linecap', 'round');
    svg.appendChild(path);
    return svg;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function buildDialog() {
    var dlg = document.createElement('dialog');
    dlg.id = 'supplementa-bis';
    dlg.className = 'supplementa-bis';
    dlg.setAttribute('aria-labelledby', 'supplementa-bis-title');

    var closeBtn = el('button', 'supplementa-bis__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('data-bis-close', '');
    closeBtn.setAttribute('aria-label', config.close || '');
    closeBtn.appendChild(closeIcon());

    titleEl = el('h2', 'supplementa-bis__title');
    titleEl.id = 'supplementa-bis-title';

    introEl = el('p', 'supplementa-bis__intro', config.intro || '');
    messageEl = el('p', 'supplementa-bis__message');
    messageEl.hidden = true;

    fieldsEl = el('div', 'supplementa-bis__fields');
    var label = el('label', 'supplementa-bis__label', config.emailLabel || '');
    label.htmlFor = 'supplementa-bis-email';
    emailInput = document.createElement('input');
    emailInput.id = 'supplementa-bis-email';
    emailInput.className = 'supplementa-bis__input';
    emailInput.type = 'email';
    emailInput.autocomplete = 'email';
    emailInput.required = true;
    emailInput.value = config.email || '';

    submitBtn = el('button', 'btn btn--primary w-full', config.submit || '');
    submitBtn.type = 'button';
    submitBtn.setAttribute('data-bis-submit', '');

    fieldsEl.appendChild(label);
    fieldsEl.appendChild(emailInput);
    fieldsEl.appendChild(submitBtn);
    dlg.appendChild(closeBtn);
    dlg.appendChild(el('p', 'supplementa-bis__kicker', config.heading || ''));
    dlg.appendChild(titleEl);
    dlg.appendChild(introEl);
    dlg.appendChild(messageEl);
    dlg.appendChild(fieldsEl);

    dlg.addEventListener('click', function (event) {
      if (event.target === dlg) dlg.close();
    });
    dlg.addEventListener('close', function () {
      if (opener && typeof opener.focus === 'function') opener.focus();
    });
    closeBtn.addEventListener('click', function () {
      dlg.close();
    });
    submitBtn.addEventListener('click', submit);

    document.body.appendChild(dlg);
    return dlg;
  }

  function resetDialog() {
    messageEl.hidden = true;
    messageEl.textContent = '';
    messageEl.classList.remove('is-error');
    introEl.hidden = false;
    fieldsEl.hidden = false;
    submitBtn.disabled = false;
    submitBtn.textContent = config.submit || '';
    dialog.dataset.submitting = '';
  }

  function showMessage(text, isError) {
    messageEl.hidden = false;
    messageEl.textContent = text;
    messageEl.classList.toggle('is-error', isError);
  }

  function submit() {
    if (dialog.dataset.submitting === '1') return;

    var email = emailInput.value.trim();
    var variantId = dialog.dataset.variantId || '';
    emailInput.value = email;
    if (!email || !variantId || !emailInput.checkValidity()) {
      emailInput.reportValidity();
      return;
    }

    dialog.dataset.submitting = '1';
    submitBtn.disabled = true;
    submitBtn.textContent = config.submitting || '…';
    messageEl.hidden = true;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(config.companyId || ''), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-06-15',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.ok) return null;
        return res.json().catch(function () { return null; }).then(function (data) {
          var detail = data && data.errors && data.errors[0] && data.errors[0].detail;
          var error = new Error(detail || 'Back in stock request failed');
          error.status = res.status;
          throw error;
        });
      })
      .then(function () {
        introEl.hidden = true;
        fieldsEl.hidden = true;
        showMessage(config.success || '', false);
      })
      .catch(function (err) {
        console.error('[supplementa-bis]', err);
        submitBtn.disabled = false;
        submitBtn.textContent = config.submit || '';
        showMessage(config.error || '', true);
      })
      .finally(function () {
        dialog.dataset.submitting = '';
      });
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-bis-open]');
    if (!openBtn) return;
    if (!dialog) dialog = buildDialog();
    opener = openBtn;
    dialog.dataset.variantId = openBtn.getAttribute('data-variant-id') || '';
    titleEl.textContent = openBtn.getAttribute('data-product-title') || '';
    resetDialog();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
      emailInput.focus();
    }
  });
})();
